export default __webpack_public_path__ + "static/figure-gallery-6-reference-c066453e51e83b7d3b637ebe8976962e.jpg";